import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
    // Section name shown in the default fallback and console log, e.g. "Resume".
    section?: string;
}

interface State {
    hasError: boolean;
}

// Catches render/lifecycle errors in its subtree so one broken section (bad
// Contentful data, a third-party widget throwing, etc.) can't blank the whole
// page. Does not catch errors from event handlers, async code, or SSR.
class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(`[ErrorBoundary${this.props.section ? `: ${this.props.section}` : ''}]`, error, errorInfo.componentStack);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback !== undefined) {
                return this.props.fallback;
            }

            return (
                <div className="error-boundary-fallback" role="alert">
                    <p>Something went wrong{this.props.section ? ` loading ${this.props.section}` : ''}. Please try refreshing the page.</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
